export default __webpack_public_path__ + "static/media/gallery-img03.7b68b178.jpg";